import { render } from "./dropZone2Component.vue?vue&type=template&id=14274454&scoped=true"
import script from "./dropZone2Component.vue?vue&type=script&lang=js"
export * from "./dropZone2Component.vue?vue&type=script&lang=js"

import "./dropZone2Component.vue?vue&type=style&index=0&id=14274454&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14274454"]])

export default __exports__